import React, { forwardRef, useState } from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { apiCreatePriceprofile, apiGetPriceprofile } from '@store';
import { showToast } from '@utils';
import { CustomModal } from '@components';

const product_option = [
    { value: 'THE', label: 'THE' },
    { value: 'PEG', label: 'PEG' }
];

const CreatePriceProfile = forwardRef(({ handleClose }, ref) => {
    const dispatch = useDispatch();
    const [state, setState] = useState({
        name: '',
        product: '',
        myFile: null
    });
    const [errors, setErrors] = useState({});

    const validateField = (name) => {
        const value = state[name];
        if (name === 'name' && (!value || value.trim() === ''))
            return 'Name is required';
        if (name === 'product' && (!value || value.trim() === ''))
            return 'Product is required';
        if (name === 'myFile' && !value) return 'File is required';
        return '';
    };

    const handleBlur = (e) => {
        const name = e.target.name || e.target.id;
        setErrors((prev) => ({ ...prev, [name]: validateField(name) }));
    };

    const handleChange = (e) => {
        const key = e.target.name || e.target.id;
        if (errors[key]) {
            setErrors({ ...errors, [key]: '' });
        }
        setState({
            ...state,
            [key]: e.target.value
        });
    };

    const handleFileChange = (e) => {
        if (errors.myFile) {
            setErrors({ ...errors, myFile: '' });
        }
        setState({
            ...state,
            myFile: e.target.files[0]
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const field of ['name', 'product', 'myFile']) {
            const msg = validateField(field);
            if (msg) newErrors[field] = msg;
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            showToast('error', 'Please fill all required fields correctly');
            return;
        }

        const formData = new FormData();
        formData.append('name', state.name);
        formData.append('product', state.product);
        formData.append('myFile', state.myFile);

        const response = await dispatch(apiCreatePriceprofile(formData));
        if (response.meta.requestStatus === 'fulfilled') {
            dispatch(apiGetPriceprofile());
            handleClose();
            showToast('success', 'Price Profile created successfully');
        } else if (response.meta.requestStatus === 'rejected') {
            showToast('error', response.payload || 'An error occurred');
        } else {
            showToast('error', 'An error occurred');
        }
    };

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            modalTitle="Create Price Profile"
            disabled={!state.name || !state.product || !state.myFile}
        >
            <FormControl
                fullWidth={true}
                variant="outlined"
                sx={{ mb: 2 }}
                error={!!errors.name}
            >
                <InputLabel id="nameLabel">Name *</InputLabel>
                <OutlinedInput
                    id="name"
                    label="Name *"
                    name="name"
                    value={state.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                />
                {errors.name && (
                    <span className="text-red-500 text-xs">{errors.name}</span>
                )}
            </FormControl>
            <FormControl fullWidth error={!!errors.product}>
                <InputLabel id="demo-simple-select-label">Product *</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Product *"
                    name="product"
                    value={state.product}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                >
                    {product_option.map((product, index) => (
                        <MenuItem key={index} value={product.value}>
                            {product.label}
                        </MenuItem>
                    ))}
                </Select>
                {errors.product && (
                    <span className="text-red-500 text-xs">
                        {errors.product}
                    </span>
                )}
            </FormControl>
            <FormControl
                fullWidth={true}
                variant="outlined"
                sx={{ mt: 2 }}
                error={!!errors.myFile}
            >
                <InputLabel
                    id="fileLabel"
                    sx={{ bgcolor: '#F5F5F5', px: 1 }}
                    shrink
                >
                    File *
                </InputLabel>
                <OutlinedInput
                    id="myFile"
                    type="file"
                    label="File *"
                    name="myFile"
                    onChange={handleFileChange}
                    onBlur={handleBlur}
                    required
                />
                {errors.myFile && (
                    <span className="text-red-500 text-xs">
                        {errors.myFile}
                    </span>
                )}
            </FormControl>
        </CustomModal>
    );
});

export default CreatePriceProfile;